import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { 
  apiGetPDFData, 
  apiPostPDFData, 
  UploadTemplateImage, 
  getTemplateImage, 
  getGuests, 
  postSendTestEmail, 
  postSendLiveEmail,
  postSendQRCodeEmail,
  postUploadFullPDF,
  apiGetFontList,
} from "./Api";

const initialState = {
  data: {
    txtColor: "dark",
    wedP1: "",
    wedP2: "",
    engP1: "",
    tyP1: "",
    stdP1: "",
    annLnk: false,
    dateLnk: false,
    wwLnk: true,
    wwCust: false,
    wwUrl: "",
    upload: false,
    PDFpages: [],
    PDFpset: [],
    hFont: "Lato Bold",
    bFont: "Lato",
    color1: "#000000",
    color2: "#000000",
  },
  image: ""
}

export const getFontList = createAsyncThunk(
  "pdf/getFontList",
  async (data) => {
    const response = await apiGetFontList(data);
    return response.data;
  }
);

export const getPDFData = createAsyncThunk(
  "pdf/getPdfData",
  async (data) => {
    const response = await apiGetPDFData(data);
    return response.data;
  }
);
export const getPDFImage = createAsyncThunk(
  "pdf/getPDFImage",
  async (data) => {
    const response = await getTemplateImage(data);
    return response.data;
  }
);

export const getGuestList = createAsyncThunk(
  "pdf/getGuestList",
  async (data) => {
    const response = await getGuests(data);
    return response.data;
  }
);

export const savePDFData = createAsyncThunk(
  "pdf/savePDFData",
  async (data) => {
    const response = await apiPostPDFData(data);
    return response.data;
  }
);

export const uploadPDFImage = createAsyncThunk(
  "pdf/uploadPDFImage",
  async (data) => {
    const response = await UploadTemplateImage(data);
    return response.data;
  }
);

export const sendTestEmail = createAsyncThunk(
  "pdf/sendTestEmail",
  async (data) => {
    const response = await postSendTestEmail(data);
    return response.data;
  }
);

export const sendLiveEmail = createAsyncThunk(
  "pdf/sendTestEmail",
  async (data) => {
    const response = await postSendLiveEmail(data);
    return response.data;
  }
);

export const sendQRCodeEmail = createAsyncThunk(
  "pdf/sendQRCodeEmail",
  async (data) => {
    const response = await postSendQRCodeEmail(data);
    return response.data;
  }
);

export const uploadFullPDF = createAsyncThunk(
  "pdf/uploadFullPDF",
  async (data) => {
    const response = await postUploadFullPDF(data);
    return response.data;
  }
);

const pdfSlice = createSlice({
  name: "pdf",
  initialState,
  reducers: {
    setPDFData: (state = initialState, action) => {
      state.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPDFData.fulfilled, (state, action) => {
        state.data=action.payload;
      })
      .addCase(uploadPDFImage.fulfilled, (state, action) => {
        state.image = action.payload.url;
      })
      .addCase(getPDFImage.fulfilled, (state, action) => {
        state.image = action.payload.url;
      })
    },
});

export const { setPDFData } = pdfSlice.actions;
export default pdfSlice.reducer;
